const CONTAINER_ID = 'paymentBrick_container';

const SCRIPT_ID = 'MercadopagoScript';

const SCRIPT_URL = 'https://sdk.mercadopago.com/js/v2';

export { CONTAINER_ID, SCRIPT_ID, SCRIPT_URL };
